import { EventDispatcher } from '../events';

// SVGSpriteの親クラス

export default class DisplayObject extends EventDispatcher {
  public name: string;

  public x: number;

  public y: number;

  public rotation: number;

  // public alpha:number;
  // public parent:DisplayObject;
}
